var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Button } from '../../Button/Button';
import CheckIcon from './Icons/CheckIcon/CheckIcon';
import { InputIconError } from '../InputIconError/InputIconError';
import UploadIcon from './Icons/UploadIcon/UploadIcon';


import { fileToBase64 } from './utils';
var FilePickerInput = function (_a) {
    var className = _a.className, name = _a.name, error = _a.error, _b = _a.uploadLabel, uploadLabel = _b === void 0 ? 'Upload' : _b, _c = _a.replaceLabel, replaceLabel = _c === void 0 ? 'Replace' : _c, _d = _a.fileRequestedLabel, fileRequestedLabel = _d === void 0 ? 'File' : _d, _e = _a.retryLabel, retryLabel = _e === void 0 ? 'Retry' : _e, onChange = _a.onChange, acceptedFileFormats = _a.acceptedFileFormats;
    var inputRef = React.useRef(null);
    var _f = React.useState(null), selectedFile = _f[0], setSelectedFile = _f[1];
    var handleChange = React.useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var files, fileContent, lines, linesBody, value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    files = event.target.files;
                    if (!files || files.length === 0) {
                        // if user cancels file selection, don't set selected file to null
                        return [2 /*return*/];
                    }
                    setSelectedFile(files[0]);
                    return [4 /*yield*/, fileToBase64(files[0])];
                case 1:
                    fileContent = _a.sent();
                    lines = fileContent.split('\n');
                    linesBody = lines.filter(function (line) { return !line.includes('--BEGIN') && !line.includes('--END'); });
                    value = linesBody.join('');
                    onChange === null || onChange === void 0 ? void 0 : onChange({ name: name, value: value });
                    return [2 /*return*/];
            }
        });
    }); }, [onChange]);
    var handleButtonClick = React.useCallback(function () {
        var _a;
        if (!inputRef.current) {
            return;
        }
        // open the file picker
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    var classNames = ['pluggy', 'file-picker-input'];
    if (className) {
        classNames.push(className);
    }
    if (selectedFile) {
        classNames.push('filled');
    }
    if (error) {
        classNames.push('error');
    }
    var combinedClassNames = classNames.join(' ');
    return (React.createElement(Button, { className: combinedClassNames, onClick: handleButtonClick, type: 'button' },
        error ? (React.createElement("div", { className: 'upload filled error' },
            React.createElement("div", { className: 'icon' },
                React.createElement(InputIconError, { size: 16 })),
            React.createElement("div", { className: 'label' },
                error,
                React.createElement(Button, { link: true }, retryLabel)))) : selectedFile ? (React.createElement("div", { className: 'upload filled' },
            React.createElement("div", { className: 'label' },
                React.createElement("div", { className: 'file-name' },
                    React.createElement("strong", null, selectedFile.name)),
                React.createElement(Button, { link: true },
                    " ",
                    replaceLabel)),
            React.createElement("div", { className: 'icon' },
                React.createElement(CheckIcon, null)))) : (React.createElement("div", { className: 'upload empty' },
            React.createElement("div", { className: 'label' },
                uploadLabel,
                " ",
                React.createElement("strong", null, fileRequestedLabel)),
            React.createElement("div", { className: 'icon' },
                React.createElement(UploadIcon, null)))),
        React.createElement("input", { type: 'file', ref: inputRef, className: 'hidden-input', onChange: handleChange, accept: acceptedFileFormats && acceptedFileFormats.join(',') })));
};
export { FilePickerInput };
